import Vue from "vue";
import VueGtm from "@gtm-support/vue2-gtm";
import * as _ from "lodash-es";
import router from "../router";

const environment = BACKEND.env;

export default function (config) {
    if (environment == "master" && !_.isEmpty(config.equalweb_sitekey) && !_.isEmpty(BACKEND.nonce)) {
        window.interdeal = {
            "sitekey": config.equalweb_sitekey,
            "Position": "left",
            "domains": {
                "js": "https://cdn.equalweb.com/",
                "acc": "https://access.equalweb.com/"
            },
            "nonce" : BACKEND.nonce,
            "Menulang": "PT",
            "showTooltip": true,
            "btnStyle": {
                "vPosition": [
                    "20%",
                    "80%"
                ],
                "margin": [
                    "0",
                    "0"
                ],
                "scale": [
                    "0.5",
                    "0.5"
                ],
                "color": {
                    "main": "#386097",
                    "second": "#ffffff"
                },
                "icon": {
                    "outline": true,
                    "type": 1,
                    "outlineColor": "#ffffff",
                    "shape": "circle"
                }
            }
        };
        (function(doc, head, body){
            var coreCall             = doc.createElement('script');
            coreCall.src             = interdeal.domains.js + 'core/5.2.0/accessibility.js';
            coreCall.defer           = true;
            coreCall.integrity       = 'sha512-fHF4rKIzByr1XeM6stpnVdiHrJUOZsKN2/Pm0jikdTQ9uZddgq15F92kUptMnyYmjIVNKeMIa67HRFnBNTOXsQ==';
            coreCall.crossOrigin     = 'anonymous';
            coreCall.setAttribute('nonce', BACKEND.nonce);
            coreCall.setAttribute('data-cfasync', true );
            body? body.appendChild(coreCall) : head.appendChild(coreCall);
        })(document, document.head, document.body);
    } else if (environment == "local" || environment == "develop") {

    }
}
